import { Controller } from 'stimulus';

class FloatingMenu extends Controller {
  connect() {
    const observer = new IntersectionObserver(this.onObservation.bind(this), {
      rootMargin: '-100px',
    });

    this.linkTargets.forEach((linkTarget) => {
      const id = linkTarget.getAttribute('href');
      const target = document.querySelector(id);

      if (!target) {
        throw new Error(`Could not find element for ID ${id}`);
      }

      observer.observe(target);
    });
  }

  onObservation(entries) {
    const intersectingElements = [];

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        intersectingElements.push(entry);
      }
    });

    if (intersectingElements.length) {
      this.highlightIntersection(intersectingElements[0]);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onLinkClick(event) {
    event.preventDefault();

    const link = event.currentTarget;

    const scrollTarget = document.querySelector(link.getAttribute('href'));

    const scrollTargetTop = scrollTarget.getBoundingClientRect().top + window.scrollY;

    window.scrollTo(0, scrollTargetTop - 30);

    scrollTarget.classList.add('is-highlighted');

    setTimeout(() => {
      scrollTarget.classList.remove('is-highlighted');
    }, 3000);
  }

  onPrev() {
    const elementWidth = this.element.offsetWidth;
    this.listTarget.scrollTo(this.listTarget.scrollLeft - (elementWidth / 2), 0);
  }

  onNext() {
    const elementWidth = this.element.offsetWidth;
    this.listTarget.scrollTo(this.listTarget.scrollLeft + (elementWidth / 2), 0);
  }

  highlightIntersection(intersectingElement) {
    this.linkTargets.forEach((linkTarget) => {
      linkTarget.classList.remove('is-highlighted');

      if (`#${intersectingElement.target.id}` === linkTarget.getAttribute('href')) {
        linkTarget.classList.add('is-highlighted');

        this.listTarget.scrollTo(linkTarget.offsetLeft, 0);
      }
    });
  }
}

FloatingMenu.targets = [
  'list',
  'link',
];

export default FloatingMenu;
